import type { SideBarDef } from 'ag-grid-community'
import type { AgGridReactProps } from 'ag-grid-react'

import SkeletonLoader from '~/components/SkeletonLoader'

export const sideBar: SideBarDef = {
  toolPanels: [
    {
      iconKey: 'columns',
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      maxWidth: 290,
      minWidth: 290,
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressPivotMode: true,
        suppressRowGroups: true,
        suppressValues: true,
      },
      width: 290,
    },
    {
      iconKey: 'filter',
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      maxWidth: 400,
      minWidth: 180,
      toolPanel: 'agFiltersToolPanel',
      width: 280,
    },
  ],
}

export const commonProps: AgGridReactProps = {
  autoSizeStrategy: {
    type: 'fitGridWidth',
  },
  columnMenu: 'legacy',
  defaultColDef: {
    resizable: true,
    sortingOrder: ['asc', 'desc', null],
  },
  domLayout: 'autoHeight',
  ensureDomOrder: true,
  getContextMenuItems: () => ['copy'],
  headerHeight: 40,
  loadingOverlayComponent: SkeletonLoader,
  rowHeight: 55,
  selectionColumnDef: {
    minWidth: 50,
    pinned: 'left',
  },
  suppressPaginationPanel: true,
  tooltipShowDelay: 500,
}
